// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PhotosUploadScreen":"qr_a bib_ea bib_qt bib_a bib_w"};